import { useAuthContext } from 'contexts';
import moment from 'moment';
import { fhirGet } from 'services';
import useSWR from 'swr';
import type { SWRConfiguration } from 'swr';
import type { CommunicationData } from 'types';
import { defaultSWROptions } from 'utils';

type UseGetZendeskCommunicationsProps = {
  patientId?: string | undefined;
};

export const useGetZendeskCommunications = ({ patientId }: UseGetZendeskCommunicationsProps) => {
  const { token } = useAuthContext();

  const query = 'medium=zendesk';

  const url = `/Communication/?${query}${patientId ? `&patient=${patientId}` : ''}`
  const swrOptions: SWRConfiguration = {
    ...defaultSWROptions,
  };

  const {
    data: communicationsData,
    error: communicationsError,
    isValidating: isLoading,
    mutate: communicationsMutate,
    // `fhirGet` resolves `CommunicationData | undefined` when the key is not ready,
    // while swr 0.5.7's fetcher parameter declares no `undefined`.
  } = useSWR<CommunicationData, string>([url, token], fhirGet as () => Promise<CommunicationData>, {
    ...swrOptions,
    onSuccess: (data) => {
      if (data?.entry?.length > 0) {
        data.entry.sort((a, b) => {
          const dateA = moment(a.resource?.sent || a.resource?.received);
          const dateB = moment(b.resource?.sent || b.resource?.received);
          return dateB.valueOf() - dateA.valueOf();
        });
      }
    },
  });

  return {
    communicationsData,
    communicationsError,
    communicationsMutate,
    isLoading,
  };
};
